// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/drawer/style/index.less
// module id = 1090
// module chunks = 1